module.exports = __webpack_public_path__ + "static/img/image_solutions_web_01.d4ab856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_web_01.png
// module id = MmDw
// module chunks = 10